import { ComponentDesignSummariesAndTimestamps, ComponentDesignSummary } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function fetchBulk(componentDesignGuids: readonly string[]): Promise<ComponentDesignSummary[]> {
  return DesignService.post(`componentDesignSummaries/bulk`, { data: componentDesignGuids });
}

export function fetchBulkWithTimestamps(
  componentDesignGuids: readonly string[],
): Promise<ComponentDesignSummariesAndTimestamps> {
  return DesignService.post(`componentDesignSummaries/bulkWithTimestamps`, { data: componentDesignGuids });
}
